import SpotIllustration from "@/assets/svgs/SpotIllustration.svg";
import SpotIllustrationMobile from "@/assets/svgs/SpotIllustrationMobile.svg";
import { SectionHeadingType } from "@/components/atoms/SectionHeading";
import CtaButtonGroup, { CtaType } from "@/components/molecules/CtaButtonGroup";
import Image from "next/image";
import Heading from "../atoms/Heading";
export type FeatureCTASectionPropType = {
  title: SectionHeadingType;
  description: string;
  ctas: CtaType[];
};

const FeatureCTASection = ({
  title,
  description,
  ctas,
}: FeatureCTASectionPropType) => {
  return (
    <div className="relative overflow-hidden bg-purple-0 sm:bg-inherit ">
      <div className="container flex flex-col gap-4 py-4 sm:py-0">
        <div className="flex items-center justify-between gap-4 text-start">
          <div className="flex flex-col items-start gap-6 sm:rounded-2xl sm:bg-purple-0 sm:p-6">
            <div className="flex flex-col justify-center gap-1.5 sm:gap-2">
              <Heading
                heading={title}
                fontStyle="text-title-20 sm:text-title-32"
                as="h3"
              />
              <p className="max-w-lg text-body-14 text-grey-4">{description}</p>
            </div>

            <div className="hidden sm:flex">
              <CtaButtonGroup ctas={ctas} gap="gap-4" align="sm:center" />
            </div>
          </div>
          <Image className="hidden sm:block" src={SpotIllustration} alt="" />
          <Image className="sm:hidden" src={SpotIllustrationMobile} alt="" />
        </div>
        <div className="sm:hidden">
          <CtaButtonGroup ctas={ctas} gap="gap-3" />
        </div>
      </div>
    </div>
  );
};

export default FeatureCTASection;
